export const environment = {
  version: '1.0.77',
  production: true,
  //
  // keycloakUrl: 'http://10.10.2.190:3000/', //karthi
  // keycloakUrl: 'http://10.10.2.159:3000/', //Ciril
  // keycloakUrl: 'http://10.10.5.201:8080/', //staging
  // keycloakUrl: 'http://10.10.2.186:3000/', //Shabaz
  // keycloakUrl: 'https://uat-keycloak.erpone.app/', //cloud
  // keycloakUrl: 'https://auth.erpone.app/', //production
  // keycloakUrl: 'https://erponestaging-keycloak.nomnom.net.in/',
  // keycloakUrl: 'http://10.10.3.201:4000/', //Mukunthan

  keycloakUrl: 'https://auth.wopt.in/',
  // keycloakUrl: 'http://10.10.2.134:4000/',  //Shashank C
  keycloakRealm: 'visionerp',
  clientId: 'frontend',

  // dataApiUrl: 'http://10.10.2.179:8000/', //karthi
  dataApiUrl: 'https://vision-be.wopt.in/',
  // dataApiUrl: 'https://be.erpone.app/',

  // dataApiUrl: 'https://erponestaging-be.nomnom.net.in/',ch
  // dataApiUrl: 'http://10.10.2.89:8000/', //Deepak

  // dataApiUrl: 'http://10.10.5.201:8000/', //staging
  // dataApiUrl: 'http://10.10.5.55:8000/', //stagings

  // dataApiUrl: 'http://10.10.3.235:8000/', //Mukunthan
  // dataApiUrl: 'http://10.10.3.20:8000/', //Shashank C
  //
  wsUrl: 'wss://vision-be.wopt.in/ws',
  // wsUrl: 'wss://be.erpone.app/ws',
  // wsUrl:'ws:/10.10.3.222:7000/ws',
  // wsUrl: 'ws:/10.10.3.54:7000/ws',
  // wsUrl:'ws:/10.10.2.98:7000/ws'
  // wsUrl: 'ws:/10.10.3.62:8001/ws',

  // wsUrl: 'wss://localhost:8000',
  // wsUrl: 'wss://erponestaging-be.nomnom.net.in/',

  // keycloakUrl: 'https://uat-keycloak.erpone.app/', //cloud

  // dataApiUrl: 'https://uat-be.erpone.app/',

  // wsUrl: 'wss://uat-be.erpone.app/ws',
};
